import React, { FC, useEffect } from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';
import { find, flatten } from 'lodash';
import map from 'lodash/map';
import { customTheme } from 'theme';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { Select } from 'components/DataEntry';
import { useSearchParamFunctions } from 'containers/App/hooks/useSearchParamFunctions';
import { DataTables } from 'containers/Visibility/Data/Components/DataTables';
import {
  dataNavList,
  VISIBILITY_DATA_TAB_STORAGE_KEY,
} from 'containers/Visibility/Data/Components/utils';
import { useSearchParams } from 'hooks/useSearchParams';

export const DataTabs: FC = () => {
  const defaultType = dataNavList[0]?.options?.[0];
  const [type, setType] = React.useState(defaultType);
  const params = useSearchParams<{ tab: string }>();
  const { updateValue } = useSearchParamFunctions();
  const storedVisibilityDataTab = localStorage.getItem(
    VISIBILITY_DATA_TAB_STORAGE_KEY,
  );
  const tab = params.tab || storedVisibilityDataTab;

  // Keep the displayed tab and the persisted tab selection aligned.
  useEffect(() => {
    const options = flatten(map(dataNavList, o => o?.options));
    const option = find(options, o => o.value === tab) || defaultType;

    setType(option);

    if (option?.value) {
      updateValue('tab', option.value, VISIBILITY_DATA_TAB_STORAGE_KEY);
    }
  }, [defaultType, tab, updateValue]);

  return (
    <Stack spacing={4} h="full">
      <HStack>
        <FilterLabelWrapper>VIEW BY</FilterLabelWrapper>
        <Box>
          <Select
            options={dataNavList}
            value={type}
            onChange={option => {
              updateValue(
                'tab',
                option?.value,
                VISIBILITY_DATA_TAB_STORAGE_KEY,
              );
            }}
            showIconInValueContainer
            showClearIndicator={false}
            isAFilter
          />
        </Box>
      </HStack>
      <Box
        border="0.5px solid"
        borderColor={customTheme.colors.gray['200']}
        borderRadius={6}
        p={4}
        w="full"
        h="full"
      >
        <DataTables />
      </Box>
    </Stack>
  );
};
